module.exports = __webpack_public_path__ + "assets/img/041905.15855a5f.svg";